<template>
  <div v-if="thumbs.length" class="activity-photo-gallery">
    <img
      v-for="(thumb, index) in thumbs"
      :key="`${thumb}-${index}`"
      :src="thumb"
      :alt="t('common.activityCard.mobileImage', { index: index + 1 })"
      @click="handleOpen(origins[index] || thumb)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { openImageModal } from '~/composables/useImageModal';

const props = defineProps({
  /** "a.png|b.png|c.png" 형태 (상대경로 또는 절대 URL) */
  thumbList: {
    type: String,
    default: '',
  },
  /** "a.png|b.png|c.png" 형태 (상대경로 또는 절대 URL) */
  originList: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const config = useRuntimeConfig();

const normalizeBaseUrl = base => {
  if (!base) return '';
  return base.endsWith('/') ? base : `${base}/`;
};

const toFullUrl = (path, baseUrl) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path) || path.startsWith('data:')) return path;
  return `${baseUrl}${path.replace(/^\//, '')}`;
};

const splitPaths = value =>
  (value || '')
    .split('|')
    .map(s => s.trim())
    .filter(Boolean);

const thumbs = computed(() => {
  const baseUrl = normalizeBaseUrl(config.public.awsCdnUrl || '');
  return splitPaths(props.thumbList).map(path => toFullUrl(path, baseUrl));
});

const origins = computed(() => {
  const baseUrl = normalizeBaseUrl(config.public.awsCdnUrl || '');
  return splitPaths(props.originList).map(path => toFullUrl(path, baseUrl));
});

const handleOpen = originPath => {
  if (!originPath) return;
  openImageModal(originPath, 'max-width:100%; height:auto; display:block; margin:0 auto;');
};
</script>

<style scoped lang="scss">
.activity-photo-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  img {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }
  }
}
</style>
